<template>
    
    <h3>Complete your rider experience</h3>

    <div id="related-items-scroller" class="horizontal-scroller" :class="rpDown ? 'grabbing' : ''" @mousedown="mouseDown">
        <div class="items-container">
            <div v-for="item in Cart.RelatedProducts" :key="item.Id" class="item">
                <a :href="item.URL" class="item-link"></a>
                <div class="inner">
                    <picture>
                        <!--<source media="(max-width: 768px)" srcset="@item.ImageMobile">-->
                        <img :src="item.Image">
                    </picture>
                    <div class="text">
                        <!--<p class="bestfor">
                            @item.BestForLabel: <span class="bestforvalue">@item.BestForValue</span>
                        </p>-->
                        <p class="model">{{item.Name}}</p>
                        <p class="price">
                            <span class="newprice">{{item.Price}}</span>
                            <span v-if="item.PriceOriginalToFormat != null && item.PriceOriginalToFormat.length > 0 && item.PriceOriginalToFormat != item.Price">
                                <span class="sr-only">Original price: </span>
                                <span class="oldprice">{{item.PriceOriginalToFormat}}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    

    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    //import ref from 'vue';

    //const myDiv = ref <HTMLDivElement | null> (null);

    export default {
        name: 'RelatedProducts',
        mixins: [cartMixin, generalMixin],
        template: '#related-products-template',
        data: function () {
            return {
                rpX: null,
                rpLeft: null,
                rpDown: null
            }
        },
        methods: {
            mouseDown(e) {                
                e.preventDefault();
                // get element
                var myScroller = document.getElementById('related-items-scroller');
                // down?
                this.rpDown = true;
                 // position of click within scroller
                this.rpX = e.pageX;
                // left position of scroller at start of click
                this.rpLeft = myScroller.scrollLeft;
            },
            mouseMove(e) {
                if (this.rpDown) {
                    var newX = e.pageX;
                    Window.handleScrollerMouseMove(this.rpLeft, newX, this.rpX);
                }
            },
            mouseUp() {
                this.rpDown = false;
                Window.handleScrollerMouseUp();
            },
            
            
        },
        computed: {
        },
        created() {
            // track mouse for whole body
            document.addEventListener('mousemove', this.mouseMove);

            // track mouse up for whole body
            document.addEventListener('mouseup', this.mouseUp);

            // add interfacetexts
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
